
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.952.655h10a3.333 3.333 0 013.334 3.334v10a3.333 3.333 0 01-3.334 3.333h-10A3.333 3.333 0 01.62 13.989v-10A3.333 3.333 0 013.952.655zm11.474 14.807c.39-.391.61-.92.61-1.473v-10a2.083 2.083 0 00-2.084-2.084h-10c-1.15 0-2.083.933-2.083 2.084v10a2.083 2.083 0 002.083 2.083h10c.553 0 1.083-.22 1.474-.61z","fill":"#585858"}}),_c('path',{attrs:{"d":"M12.027 6.264a.625.625 0 00-.883 0L9.127 8.28 7.111 6.264a.625.625 0 00-.884.883l2.017 2.017-2.017 2.016a.625.625 0 00.884.884l2.016-2.017 2.017 2.017a.625.625 0 00.442.183.658.658 0 00.441-.183.625.625 0 000-.884l-2.016-2.016 2.017-2.017a.625.625 0 000-.883z","fill":"#585858"}})])
          )
        }
      }
    